export default __webpack_public_path__ + "b44a752ca8b81eff6cebb1116b8ee30e.png";